module.exports = __webpack_public_path__ + "static/media/Mazaya Still 02.d5e6733d.webp";